import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { InsuranceApp } from './InsuranceApp';
import './assets/css/index.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

const rootElement = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <InsuranceApp />
  </Provider>,
  rootElement,
);
reportWebVitals();
